import { createStore, useStore } from 'zustand';

import { ModalPropsForType } from 'containers/Modal/ModalPropsForType';
import { ModalType } from 'containers/Modal/ModalType';

type ModalData<TType extends ModalType> = {
  type: TType;
  props: ModalPropsForType<TType>;
};

const modalStore = createStore<{
  modal: ModalData<ModalType> | null;
}>(() => ({ modal: null }));

// Actions

export function showModal<TType extends ModalType>(
  type: TType,
  props: ModalPropsForType<TType>,
) {
  modalStore.setState({ modal: { type, props } });
}

export function hideModal() {
  modalStore.setState({ modal: null });
}

// Hook

export function useModalStore() {
  return useStore(modalStore);
}
